export class SendDisclosureModalConstant {
    static readonly EMAIL: string = "EMAIL"
}